import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import RoleAssignmentType from '@/Controls/RoleAssignment';
import RoleAssignmentViewModelType from '@/ViewModels/Controls/RoleAssignmentViewModel';
import { IControlFactoryConstructorParameter } from '#/CoreFrameInterfaces';

export default class RoleAssignmentFactory extends ControlFactory {

    private RoleAssignmentViewModel = ComponentManager.getViewModel<typeof RoleAssignmentViewModelType>('RoleAssignmentViewModel');
    private RoleAssignment = ComponentManager.getControl<typeof RoleAssignmentType>('RoleAssignment');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');
    private jqueryControl: JQuery;

    /**
     * @override
     */
    viewModel: RoleAssignmentViewModelType;

    public constructor(params: IControlFactoryConstructorParameter) {
        super(params);

        this.labelPosition = 'Top';
        this.colspan = 'Fill';
    }

    // @Override
    public getControl() {
        if (this.jqueryControl != null) {
            return this.jqueryControl;
        }

        this.viewModel = new this.RoleAssignmentViewModel({
            factory: this,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isDisplayed: this.isDisplayed,
            context: this.context,
            detailViewItemName: this.detailViewItem.name,
        });

        this.control = new this.RoleAssignment(this.viewModel);

        var tuple = this.control.getTuple();
        this.jqueryControl = tuple.control;

        return this.jqueryControl;
    }
}

ComponentManager.setFactory('RoleAssignment', RoleAssignmentFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('RADPresentation.DefaultViewExtensions.UIComponents.RoleAssignment', RoleAssignmentFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');